import { render, staticRenderFns } from "./badge.vue?vue&type=template&id=2b964d8f&"
import script from "./badge.vue?vue&type=script&lang=ts&"
export * from "./badge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports